import { InformationType, InformationTypeTree } from "@/common/models";
import { GqlMockCall } from "@/gql/lib";
import { GqlCallsKey } from "../demo/gql.resolver";

// @ts-ignore
export const executives: Record<Partial<GqlCallsKey>, GqlMockCall> = {
  /* "l1-exposures": {
    delay: 2000,
    payload: async ({ is_common, label_id }) => {
      const { SharedState } = await import("@/common/state");
      const labels = SharedState.typesByCategories.value.get(
        label_id
      ) as InformationType[];
      return {
        objects: labels.map(({ id, labelName }) => {
          return {
            id: id,
            name: labelName,
            internal: 10,
            external: 20,
          };
        }),
        cursor: "",
      };
    },
  }, */
  "l2-exposures": {
    delay: 2000,
    payload: async ({ is_common, label_id }) => {
      const { SharedState } = await import("@/common/state");
      const parent_id = SharedState.getInfoType(label_id).parentId as string;
      console.log("parent_id : ", parent_id);
      const L2s = SharedState.info_types_tree.value // l2s
        .find((l) => l.id === parent_id)
        // l1
        ?.nested.find((l) => l.id === label_id)
        ?.nested as InformationTypeTree[];
      console.log("L2s: ", L2s);
      return {
        objects: [...(L2s || [])].map((l) => {
          return {
            id: l.id,
            name: l.labelName,
            external: 10,
            internal: 10,
          };
        }),
        cursor: "",
      };
    },
  },
  "l1-exposure-entities": {
    delay: 1000,
    payload: async () => {
      return {
        cursor: "",
        objects: Array(10)
          .fill({})
          .map((_, index) => {
            return {
              startDate: "2021-02-08T11:53:12.000Z",
              endDate: "2021-02-08T11:53:12.000Z",
              files: 1,
              count: 1,
              id: "aad8fa4a-7a9b-99fe-1d5f-34cccf74a640" + index,
              extendedData:
                '{"emailAddress":"Andrew.d@probotai.onmicrosoft.com","isDomainInternal":true,"id":"e04cacc3-936c-4bf7-a0a8-302cf52d41c2","displayName":"Andrew Davis","labelRelated":{"id":"e04cacc3-936c-4bf7-a0a8-302cf52d41c2","userPrincipalName":"Andrew.d@probotai.onmicrosoft.com","mail":"Andrew.d@probotai.onmicrosoft.com","displayName":"Andrew Davis","givenName":null,"surname":null,"preferredLanguage":null,"usageLocation":"IL","country":null,"state":null,"city":null,"streetAddress":null,"businessPhones":[],"mobilePhone":null,"faxNumber":null,"companyName":null,"department":"Finance","jobTitle":"Payroll Controller","officeLocation":null}}',
              name: "Andrew Davis",
              type: "EMPLOYEE",
              externalId: "Andrew.d@probotai.onmicrosoft.com",
              selected: false,
            };
          }),
      };
    },
  },
  "top10-exposures": {
    delay: 2000,
    payload: async ({ is_common, label_id, type }) => {
      return {
        objects: Array(10)
          .fill({})
          .map((_, index) => {
            return {
              id: "9a7b0786-71a0-64b9-26b9-1e09282d6758_" + index,
              name: `${type}${index}@cognni.ai`,
              count: 10,
            };
          }),
        cursor: "",
      };
    },
  },
};
